const otpDigitLimitEnum = Object.freeze([
    {
        id: "4",
        name: "4",
    },
    {
        id: "6",
        name: "6",
    },
    {
        id: "8",
        name: "8",
    },
]);
export default otpDigitLimitEnum;
